const updatesData = [
  { time: '10分钟前', title: '某知名导演新片片场冲突，助理与群演爆发肢体接触', tag: '最新' },
  { time: '28分钟前', title: '当红小花旦综艺录制中途离场，疑似与节目组发生分歧', tag: '热议' },
  { time: '1小时前', title: '知名歌手深夜发文暗讽同行，三小时后秒删引网友截图', tag: '热议' },
  { time: '2小时前', title: '某男团成员被拍到与经纪人深夜同回公寓，粉丝炸锅', tag: '' },
  { time: '3小时前', title: '网红带货数据造假产业链曝光，MCN机构连夜发声明', tag: '深度' },
  { time: '4小时前', title: '综艺选秀节目投票系统被质疑暗箱操作，节目组回应', tag: '' },
  { time: '5小时前', title: '某女演员新剧开机现场造型翻车，网友吐槽服化道太离谱', tag: '' },
  { time: '6小时前', title: '娱乐圈老牌经纪公司被曝内部贪腐，涉案金额高达千万', tag: '深度' },
  { time: '7小时前', title: '短视频平台头部创作者集体跳槽，背后资本博弈浮出水面', tag: '' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            实时快讯
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            分钟级滚动更新，第一时间掌握娱乐圈最新动态
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-5 top-0 bottom-0 w-0.5 bg-background-200"></div>

          <div className="space-y-6">
            {updatesData.map((item, idx) => (
              <div key={idx} className="relative pl-10 md:pl-12 group cursor-pointer">
                <div className="absolute left-[11px] md:left-[15px] top-1.5 w-2.5 h-2.5 rounded-full bg-primary-500 border-2 border-background-50 group-hover:scale-125 transition-transform"></div>

                <div className="flex items-start gap-3 flex-wrap">
                  <span className="text-xs text-foreground-400 whitespace-nowrap pt-0.5">{item.time}</span>
                  <h3 className="flex-1 text-sm md:text-base text-foreground-800 font-medium group-hover:text-primary-500 transition-colors leading-relaxed min-w-0">
                    {item.title}
                  </h3>
                  {item.tag && (
                    <span className={`flex-shrink-0 px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${
                      item.tag === '最新' ? 'bg-primary-100 text-primary-700' :
                      item.tag === '热议' ? 'bg-accent-100 text-accent-700' :
                      'bg-secondary-100 text-secondary-700'
                    }`}>
                      {item.tag}
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}